import getRooms from './get-rooms';
import getGames from './get-games';
import getDates from './get-dates';
import timeSlot from './get-time-slot';
import bookingPlayers from './booking-players';

// Init get rooms
const modGetRooms = new getRooms();

// init games
const modGetGames = new getGames();

// init dates
const modGetDates = new getDates();

// init time slot
const modTimeSlot = new timeSlot();

// Init players
const modPlayers = new bookingPlayers();

export default class stepOne{

    protected book_calendar: any;
    protected elForm: string = '#site-form-booking';
    protected el_rooms: string = '.select-rooms';
    protected el_games: string = '.select-games';
    protected el_time_slot: string = '.select-times-slot';
    protected el_players: string = '.select-players';
    protected el_book_calendar: string = '#book-calendar';

    constructor(
        book_calendar: any,
    ){
        
        this.book_calendar = book_calendar;

        // this.book_calendar.setOptions({
        //     datesDisabled: ['05-02-2025'],
        // });

    }

    /**
     * Init
     * @returns 
     */
    init(){
        
        // Element form
        const form = document.querySelector(this.elForm) as HTMLFormElement | null;

        if(form === null){
            
            return null;

        }

        // Get players
        const get_players = modPlayers.getPlayers(this.el_players);

        // Get rooms
        modGetRooms.get(this.el_rooms);

        // Get games
        modGetGames.get(
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
            this.book_calendar,
            get_players,
            modPlayers,
            modTimeSlot
        );

        // Get time slot
        modTimeSlot.get(
            this.book_calendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot
        );

        // Change time slot
        modTimeSlot.change(
            this.el_players,
            this.book_calendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
        );
        
        // Change date
        modGetDates.change(
            this.book_calendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
        );

        // Change players
        modPlayers.changePlayers(
            this.el_players,
            this.book_calendar,
            this.el_rooms,
            this.el_games,
            this.el_time_slot,
        );

    }

}
